<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/revenue-and-laba')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/rasio-keuangan')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">KINERJA TINGKAT KESEHATAN PERUSAHAAN YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }} {{ this.year }}</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                <div v-html="lastUpdate"></div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row mt-1">
                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-9' : 'col-md-12' ) + ' '">
                      <table style="width:100%;" border="1">
                        <tr style="background:#305496; color:#ffffff;">
                            <td class="tb-cellpadding" style="width:40px;text-align:center;">I</td>
                            <td class="tb-cellpadding">INDIKATOR KINERJA KEUANGAN</td>
                            <td class="tb-cellpadding text-center" colspan="2">RKAP {{ this.year }}</td>
                            <td class="tb-cellpadding text-center" colspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</td>
                        </tr>
                        <tr>
                            <td class="border-right"></td>
                            <td class="border-right"></td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding text-right border-right">Nilai Kinerja Keuangan</td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding text-right">Nilai Kinerja Keuangan</td>
                        </tr>
                        <tr v-for="(item,idx) in reportdata.data.indikator_kinerja_keuangan_detail" :key="item.IndicatorCode">
                            <td class="tb-cellpadding text-center border-right">{{ ++idx }}</td>
                            <td class="tb-cellpadding border-right">{{ (item.IndicatorName) }}</td>
                            <td class="text-right">{{ formatNum(item.rkap1) }}</td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ formatNum(item.rkap2) }}</b></td>
                            <td class="text-right">{{ formatNum(item.ytd1) }}</td>
                            <td class="tb-cellpadding text-right"><b>{{ formatNum(item.ytd2) }}</b></td>
                        </tr>
                        <tr v-for="item in reportdata.data.indikator_kinerja_keuangan" :key="item.indikator">
                            <td class="tb-cellpadding border-right"></td>
                            <td class="tb-cellpadding border-right"><b>{{ item.indikator }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ item.rkap }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right"><b>{{ item.ytd }}</b></td>
                        </tr>
                        <!--
                        <tr>
                            <td class="tb-cellpadding"></td>
                            <td class="tb-cellpadding"><b>Total Nilai Kinerja Keuangan</b></td>
                            <td class="tb-cellpadding"><b>64,50</b></td>
                            <td class="tb-cellpadding"><b>36,00</b></td>
                        </tr>
                        <tr>
                            <td class="tb-cellpadding"></td>
                            <td class="tb-cellpadding"><b>Klasifikasi Tingkat Kinerja Keuangan</b></td>
                            <td class="tb-cellpadding"><b>Sehat</b></td>
                            <td class="tb-cellpadding"><b>Kurang Sehat</b></td>
                        </tr>
                    -->

                        <tr style="background:#305496; color:#ffffff;">
                            <td style="text-align:center;">II</td>
                            <td class="tb-cellpadding">INDIKATOR KINERJA PERTUMBUHAN</td>
                            <td class="tb-cellpadding text-center" colspan="2">RKAP {{ this.year }}</td>
                            <td class="tb-cellpadding text-center" colspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</td>
                        </tr>
                        <tr>
                            <td class="border-right"></td>
                            <td class="border-right"></td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding border-right text-right">Nilai Kinerja Pertumbuhan</td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding text-right">Nilai Kinerja Pertumbuhan</td>
                        </tr>
                        <tr v-for="(item,idx) in reportdata.data.indikator_kinerja_pertumbuhan_detail" :key="item.IndicatorCode">
                            <td class="tb-cellpadding text-center border-right">{{ ++idx }}</td>
                            <td class="tb-cellpadding border-right">{{ (item.IndicatorName) }}</td>
                            <td class="text-right">{{ formatNum(item.rkap1) }}</td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ formatNum(item.rkap2) }}</b></td>
                            <td class="text-right">{{ formatNum(item.ytd1) }}</td>
                            <td class="tb-cellpadding text-right"><b>{{ formatNum(item.ytd2) }}</b></td>
                        </tr>
                        <tr v-for="item in reportdata.data.indikator_kinerja_pertumbuhan" :key="item.indikator">
                            <td class="tb-cellpadding border-right"></td>
                            <td class="tb-cellpadding border-right"><b>{{ item.indikator }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding border-right text-right"><b>{{ item.rkap }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right"><b>{{ item.ytd }}</b></td>
                        </tr>

                        <tr style="background:#305496; color:#ffffff;">
                            <td style="text-align:center;">III</td>
                            <td class="tb-cellpadding">INDIKATOR KINERJA OPERASIONAL</td>
                            <td class="tb-cellpadding text-center" colspan="2">RKAP {{ this.year }}</td>
                            <td class="tb-cellpadding text-center" colspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</td>
                        </tr>
                        <tr>
                            <td class="border-right"></td>
                            <td class="border-right"></td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding border-right text-right">Nilai Kinerja Operasional</td>
                            <td class="tb-cellpadding text-right">%</td>
                            <td class="tb-cellpadding text-right">Nilai Kinerja Operasional</td>
                        </tr>
                        <tr v-for="(item,idx) in reportdata.data.indikator_kinerja_operasional_detail" :key="item.IndicatorCode">
                            <td class="tb-cellpadding text-center border-right">{{ ++idx }}</td>
                            <td class="tb-cellpadding border-right">{{ (item.IndicatorName) }}</td>
                            <td class="text-right">{{ formatNum(item.rkap1) }}</td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ formatNum(item.rkap2) }}</b></td>
                            <td class="text-right">{{ formatNum(item.ytd1) }}</td>
                            <td class="tb-cellpadding text-right"><b>{{ formatNum(item.ytd2) }}</b></td>
                        </tr>
                        <tr v-for="item in reportdata.data.indikator_kinerja_operasional" :key="item.indikator">
                            <td class="tb-cellpadding border-right"></td>
                            <td class="tb-cellpadding border-right"><b>{{ item.indikator }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding border-right text-right"><b>{{ item.rkap }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right"><b>{{ item.ytd }}</b></td>
                        </tr>

                        <tr style="background:#305496; color:#ffffff;">
                            <td style="text-align:center;">IV</td>
                            <td class="tb-cellpadding">INDIKATOR KINERJA ADMINISTRASI</td>
                            <td class="tb-cellpadding text-center" colspan="2">RKAP {{ this.year }}</td>
                            <td class="tb-cellpadding text-center" colspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</td>
                        </tr>
                        <tr>
                            <td class="border-right"></td>
                            <td class="border-right"></td>
                            <td class="tb-cellpadding border-right text-right" colspan="2">Nilai Kinerja Administrasi</td>
                            <td class="tb-cellpadding text-right" colspan="2">Nilai Kinerja Administrasi</td>
                        </tr>
                        <tr v-for="(item,idx) in reportdata.data.indikator_kinerja_administrasi_detail" :key="item.IndicatorCode">
                            <td class="tb-cellpadding text-center border-right">{{ ++idx }}</td>
                            <td class="tb-cellpadding border-right">{{ (item.IndicatorName) }}</td>
                            <td class="text-right">{{ (item.rkap1) }}</td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ formatNum(item.rkap2) }}</b></td>
                            <td class="text-right">{{ (item.ytd1) }}</td>
                            <td class="tb-cellpadding text-right"><b>{{ formatNum(item.ytd2) }}</b></td>
                        </tr>
                        <tr v-for="item in reportdata.data.indikator_kinerja_administrasi" :key="item.indikator">
                            <td class="tb-cellpadding border-right"></td>
                            <td class="tb-cellpadding border-right"><b>{{ item.indikator }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding border-right text-right"><b>{{ item.rkap }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right"><b>{{ item.ytd }}</b></td>
                        </tr>

                        <tr style="background:#305496; color:#ffffff;">
                            <td style="text-align:center;">IV</td>
                            <td class="tb-cellpadding">INDIKATOR KINERJA PERUSAHAAN</td>
                            <td class="tb-cellpadding text-center" colspan="2">RKAP {{ this.year }}</td>
                            <td class="tb-cellpadding text-center" colspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</td>
                        </tr>
                        <tr v-for="(item,idx) in reportdata.data.indikator_kinerja_perusahaan_detail" :key="item.IndicatorCode">
                            <td class="tb-cellpadding text-center border-right">{{ ++idx }}</td>
                            <td class="tb-cellpadding border-right">{{ (item.IndicatorName) }}</td>
                            <td class="text-right">{{ (item.rkap1) }}</td>
                            <td class="tb-cellpadding text-right border-right"><b>{{ formatNum(item.rkap2) }}</b></td>
                            <td class="text-right">{{ (item.ytd1) }}</td>
                            <td class="tb-cellpadding text-right"><b>{{ formatNum(item.ytd2) }}</b></td>
                        </tr>
                        <tr v-for="item in reportdata.data.indikator_kinerja_perusahaan" :key="item.indikator">
                            <td class="tb-cellpadding border-right"></td>
                            <td class="tb-cellpadding border-right"><b>{{ item.indikator }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding border-right text-right"><b>{{ item.rkap }}</b></td>
                            <td></td>
                            <td class="tb-cellpadding text-right"><b>{{ item.ytd }}</b></td>
                        </tr>
                      </table>

                      <Loader v-if="loading.table"/>
                    </div>

                    <div class="col-md-3 p-0" style="border:1px solid #2F5597;" v-if="String(this.description || '').trim().length > minLengthDescription">
                        <div class="text-center" style="background:#2F5597;">
                            <h6 style="color:#ffffff;">HIGHLIGHT</h6>
                        </div>
                        <div class="p-3">
                            <div v-html="description"></div>
                            <!--
                            <ul>
                                <li style="text-align:justify;">Ytd Mei 2023, Kinerja Keuangan mendapatkan point 36 dengan kategori  Kurang Sehat.</li><br>
                                <li style="text-align:justify;">Ytd Mei 2023, Kinerja Pertumbuhan mendapatkan point 4 dengan kategori Kurang Tumbuh.</li><br>
                                <li style="text-align:justify;">Ytd Mei 2023, Kinerja Operasional mendapatkan point 10 dengan kategori Sangat Baik.</li><br>
                                <li style="text-align:justify;">Ytd Mei 2023, Kinerja Administrasi mendapatkan point 9 dengan kategori Tertib.</li><br>
                                <li style="text-align:justify;">Ytd Mei 2023, Total TKP mendapatkan point 59 dengan Kurang Sehat BBB.</li>
                            </ul>
                            -->
                            <Loader v-if="loading.description"/>
                        </div>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            reportdata: {
                data : {
                    indikator_kinerja_keuangan : [],
                    indikator_kinerja_pertumbuhan : [],
                    indikator_kinerja_operasional : [],
                    indikator_kinerja_administrasi : [],
                    indikator_kinerja_perusahaan : [],

                    indikator_kinerja_keuangan_detail : [],
                    indikator_kinerja_pertumbuhan_detail : [],
                    indikator_kinerja_operasional_detail : [],
                    indikator_kinerja_administrasi_detail : [],
                    indikator_kinerja_perusahaan_detail : [],
                },
            },

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            loading: {
                table: false,
                description: false,
            },
            description: '',

        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
        this.getData()
        this.getDescription()
    },
    methods: {
        getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/tingkat-kesehatan?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                //let responseData = response.data;
                this.reportdata = response.data
                this.lastUpdate = this.reportdata.data.last_update
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        getDescription() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/tingkat-kesehatan-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&category=table'

			this.loading.description = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.description = response.data.data.description;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.description = false;
			})     

        },

        applyFilter() {
            this.getData()
            this.getDescription()
        }
    },

}
</script>


<style>
.tb-cellpadding {
    padding: 2px 10px;
}

.border-right {
    border-right: 4px solid #ddd;
}
.border-left {
    border-right: 4px solid #ddd;
}
</style>